/**
 * Meanbook Note - System Constants
 */

export const DAILY_NOTE_TITLE_PREFIX = "ออเดอร์ประจำวัน";

export const READ_SYNC_PROFILE = Object.freeze({
  adminOrderDays: 730, // เฉพาะ Super Admin & Order Manager: ซิงค์ 2 ปี เพื่อค้นหาข้อมูลได้ครบทุกรายการทันที
  adminOrderLimit: 3000,
  staffOrderDays: 21,  // พนักงานทั่วไป: จำกัด 21 วัน
  staffOrderLimit: 450,
  packerOrderDays: 7,  // Packer & Picker: จำกัด 7 วัน (ดึงเฉพาะโน้ตออเดอร์ประจำวัน)
  packerOrderLimit: 450,
  shipperOrderDays: 2, // Shipper: จำกัด 2 วัน (ดึงเฉพาะคิวจัดส่งพัสดุ)
  shipperOrderLimit: 200
});

export const VIRTUAL_QUEUES = Object.freeze([
  "prepare-queue",
  "shipping-queue",
  "completed-queue",
  "pickup-queue",
  "undo-queue",
  "cleanup-queue",
  "pending-info-queue"
]);

export function isVirtualQueueId(id) {
  return VIRTUAL_QUEUES.includes(id);
}

export const defaultCarrierSettings = {
  ems: ["WB", "EF", "EH", "EI", "EK", "EL", "EM", "EN", "EO", "EP", "EQ", "ER", "ES", "ET", "EU", "EV", "EX", "EY", "EZ"],
  flash: ["TH", "FL"],
  spx: ["SPX"],
  dhl: ["60", "59"],
  kex: ["KEX", "KER"],
  other: []
};
